import React from 'react';
import CloseModalIcon from 'components/icons/CloseModalIcon';
import { OutlineButton } from 'components/Button';
import { ModalProps } from './index';

type AlertModalProps = {
  message: string;
  handleModal: (args: ModalProps) => void;
};

const AlertModal: React.FC<AlertModalProps> = ({ message, handleModal }) => (
  <div className="flex w-[500px] flex-col items-start justify-start space-y-6 rounded-lg bg-white p-6 shadow-md">
    <div className="inline-flex w-full items-center justify-start">
      <div className="flex-1">
        <p className="h-full flex-1 text-2xl uppercase leading-7 text-sf-blue-700">attention</p>
      </div>

      <div
        className={'cursor-pointer'}
        onClick={() =>
          handleModal({
            id: null,
            show: false,
          })
        }
      >
        <CloseModalIcon className={'h-6 w-6'} />
      </div>
    </div>
    <p className="text-base leading-snug text-sf-blue-700">{message}</p>
    <div className="inline-flex w-full items-start justify-start space-x-4">
      <div className="flex flex-1 items-center justify-center">
        <OutlineButton
          buttonSize="small"
          fullWidth={true}
          onClick={() =>
            handleModal({
              id: null,
              show: false,
            })
          }
        >
          <span className="normal-case">Ok</span>
        </OutlineButton>
      </div>
    </div>
  </div>
);

export default AlertModal;
